import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ExclusaoConsulta } from 'src/app/models/database-exclusao';
import { AbstractService } from 'src/app/services/abstract.service';
import { DatabaseExclusaoService } from 'src/app/services/db-exclusao.service';
import { DateUtils } from 'src/app/utilities/util/date-utils';

@Component({
  selector: 'habil-politica-exclusao-databases',
  templateUrl: './politica-exclusao-databases.component.html',
  styleUrls: ['./politica-exclusao-databases.component.scss']
})
export class PoliticaExclusaoDatabasesComponent implements OnInit {

  dataInicial: Date = new Date();
  dataFinal: Date = new Date();
  excluidos = false;

  list: ExclusaoConsulta[] = [];
  selected: ExclusaoConsulta[] = [];
  loading: boolean = false;

  constructor(private breadcrumbService: BreadcrumbService,
    private service: DatabaseExclusaoService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    titleService: Title) {
    this.breadcrumbService.setItems([{ label: "Política de exclusão" }]);
    titleService.setTitle("Política de exclusão - " + AbstractService.app);
  }

  buscar() {
    this.loading = true;
    this.list = [];
    this.service.fazConsulta(this.dataInicial, this.dataFinal, this.excluidos).subscribe({
      next: (val) => {
        this.loading = false;
        this.list = val;
      }
    })
  }

  excluir() {
    this.confirmationService.confirm({
      header: 'Atenção',
      message: 'Deseja realmente excluir estes bancos de dados?',
      rejectLabel: 'Não',
      acceptLabel: 'Sim',
      accept: () => {
        this.confirmaExclusao();
      }
    })
  }

  async confirmaExclusao() {
    const user = AbstractService.getLocalStorage('usuario');
    const nomeUser = user.nome;
    try {
      for (const e of this.selected) {
        const ret = await this.service.excluiDb(e.id, nomeUser).toPromise();
        this.messageService.add({
          severity: 'success',
          detail: 'Banco excluído: ' + e.cnpj + ' - ' + e.nome
        })
      }
    } catch (error) {
      console.log(error);
      this.service.handleError(error);
    }
    this.buscar();

  }

  ngOnInit(): void {
    this.dataInicial = DateUtils.incDay(this.dataInicial, -1)
    this.buscar();
  }

}
